import { memo, useEffect, useRef } from "react";
import cx from "classnames";
import { IonLabel, IonSkeletonText } from "@ionic/react";
import { shallow } from "zustand/shallow";
import WLCountdown from "../../../../../../../../Common/components/WLCountdown/WLCountdown";
import useSuperGiveAwayStore from "../../../../../../../CommonStores/giveaways/store";
import PaymentDrawTonightInterfaceStore from "../../../interface/PaymentDrawTonightInterface";
import s from "./GiveawayCard.module.scss";

const GiveawayCard: React.FC = (): JSX.Element => {
  const ongoingGiveaway = useSuperGiveAwayStore(
    (state) => state.ongoingGiveaway,
  );
  const [imgLoaded, setImgLoaded] = PaymentDrawTonightInterfaceStore(
    (state) => [state.imgLoaded, state.setImgLoaded],
    shallow,
  );
  const giveawayImgRef = useRef<HTMLImageElement>(null);
  const giveawayImgSrc =
    ongoingGiveaway?.imgUrl || ongoingGiveaway?.bannerImgUrl;

  useEffect(() => {
    const image = giveawayImgRef.current;
    if (image?.complete && image.naturalHeight > 0) {
      setImgLoaded(true);
    }
  }, [giveawayImgSrc, setImgLoaded]);

  const isLoading = !imgLoaded || !ongoingGiveaway;
  const showCountdown =
    ongoingGiveaway?.giveAwayDt != null &&
    Number.isFinite(ongoingGiveaway.giveAwayDt);

  return (
    <div className={s.giveawayContainer}>
      {showCountdown && (
        <div className={s.giveawayCountdownContainer}>
          <WLCountdown
            title="Winner Drawn In"
            expiresInDt={ongoingGiveaway.giveAwayDt}
            variant="secondsOnlyRed"
          />
        </div>
      )}
      <div className={s.giveawayCard}>
        <div
          className={cx(s.imageContainer, {
            [s.imageContainerLoading]: isLoading,
          })}
        >
          <img
            ref={giveawayImgRef}
            src={giveawayImgSrc}
            alt={ongoingGiveaway?.title}
            className={s.giveawayImg}
            onLoad={() => setImgLoaded(true)}
            loading="lazy"
            decoding="async"
          />
          <IonSkeletonText
            className={s.backgroundImgLoader}
            style={{ opacity: imgLoaded ? 0 : 1 }}
            animated
          />
        </div>
        <div className={s.giveawayDetails}>
          <IonLabel className="win-header-5 medium winnersans white ion-text-center">
            {ongoingGiveaway?.title ?? "Giveaway"}
          </IonLabel>
        </div>
      </div>
    </div>
  );
};

export default memo(GiveawayCard);
